const dataProperties = {
    screenMdFull: 1024
};

export default class VideoBox {
    constructor(elem, context) {
        if (!elem || !context) {
            throw new Error('Element and context required to initialize object');
        }

        this.$elem = $(elem);
        this.$context = $(context);
        this.$document = $(context.document);

        if (!this.$elem.hasClass('is-video-block-init')) {
            this.initGhost();
            this.setSrc();

            $(window).on('resize', $.proxy(this, 'setSrc'));
        }
    }

    initGhost() {
        this.$elem.addClass('is-video-block-init');
    }

    getWidth() {
        return Math.max($(document).width(), $(window).width());
    }

    setSrc() {
        if (this.getWidth() >= dataProperties.screenMdFull) {
            let src = this.$elem.attr('data-src');
            this.$elem.find('iframe').attr('src', src);
        }
    }
}